export class SetShiftsLoadingStatus {
    public static readonly type = '[JobsPlacements] Set shifts loading status';
}
